import React, { useContext, useEffect, useState } from 'react';
import styles from "./AssessmentInviteReminderForm.module.scss";
import { UserContext } from '../../context/UserContext';

type AssessmentInviteReminderProps = {
  isOpen: boolean;
  onToggle: Function;
  onClick: Function;
  sendingSuccessful: Boolean
  errorFound: Boolean
  row: any
};

const letterNL = `
Beste [ondernemer],

Dit is een vriendelijke herinnering om de scan te starten. Je kunt de scan [hier] starten.

Met vriendelijke groet,

[begeleider]
`;



export const AssessmentInviteReminderForm = ({
  isOpen,
  onToggle,
  onClick,
  sendingSuccessful,
  errorFound,
  row
}: AssessmentInviteReminderProps) => {
  const userContext = useContext(UserContext)
  const [message, setMessage] = useState('')

  const replaceLetterContent = (givenLetter: String) => {
    let filledInLetter = givenLetter.replace('[ondernemer]', row.founder)
    // @ts-ignore
    filledInLetter = filledInLetter.replace('[venture]', userContext.organisation.name ?? '')
    filledInLetter = filledInLetter.replace('[email begeleider]', userContext.emailAddress)
    filledInLetter = filledInLetter.replace('[begeleider]', userContext.name)
    filledInLetter = filledInLetter.replaceAll('[assessment_name]', 'Henk')

    return filledInLetter;
  }

  useEffect(() => {
      setMessage(replaceLetterContent(letterNL))
  }, [isOpen]);


  const closeModal = () => {
    onToggle()
  }

    return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <p className={styles.name}>Send reminder</p>
        <button className={styles.close} onClick={closeModal}>
          X
        </button>
      </div>
      <h2 className={styles.title}>{`Send invitation reminder`}</h2>
    {message !== null && (
        <section>
          <textarea
            className={styles.textField}
            value={message}
            onChange={
            (e) => {
              setMessage(e.target.value)
            }}
          ></textarea>
                <section className={styles.modalButtons}>
                    <button
                        className={styles.send}
                        onClick={() => {
                          onClick(message)
                        }}
                    >{`Send`}</button>
                    <button
                    className={styles.cancel}
                    onClick={closeModal}
                    >{`Cancel`}</button>
                </section>
            {sendingSuccessful && (
                <span className={styles.sendSuccessful}>Mail sent succesfully</span>
            )}
            {errorFound && (
                <span className={styles.sendFailed}>Oops, something went wrong with sending the reminder, don't worry, we're notified of the issue </span>
            )}
        </section>
    )}
    </div>
  );
};
